<template>
  <v-dialog v-model="showDialog" persistent max-width="500px">
    <v-card>
      <v-card-title class="headline" primary-title>
        Endre navn/beskrivelse
      </v-card-title>
      <v-card-text>
        <v-text-field
          label="Tegnelagets navn"
          full-width
          box
          v-model="newLayerTitle"
        ></v-text-field>

        <v-textarea
          label="Beskrivelse (valgfritt)"
          v-model="newLayerDescription"
          maxlength="500"
          box
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" flat @click="emitDialogClosedEvent"
          >Avbryt</v-btn
        >
        <v-btn
          color="primary"
          :disabled="newLayerTitle === '' || newLayerTitle == null"
          flat
          @click="updateLayerTitle"
          >Ok</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data: function() {
    return {
      newLayerTitle: "",
      newLayerDescription: "",
      showDialog: false
    };
  },
  watch: {
    active: function(newVal) {
      if (newVal == true) {
        this.newLayerTitle = this.currentName;
        this.newLayerDescription = this.currentDescription;
        this.showDialog = true;
      }
    }
  },
  props: {
    layer: Object,
    currentName: String,
    currentDescription: String,
    active: Boolean
  },
  methods: {
    ...mapActions(["updateMapProfileName", "updateMapProfileDescription"]),
    emitDialogClosedEvent() {
      this.$emit("close-dialog");
      this.showDialog = false;
    },
    updateLayerTitle: function() {
      this.updateMapProfileName({
        id: this.layer.id,
        newName: this.newLayerTitle
      });
      this.updateMapProfileDescription({
        id: this.layer.id,
        Temaforklaring: this.newLayerDescription
      });
      this.newLayerTitle = "";
      this.newLayerDescription = "";
      this.emitDialogClosedEvent();
    }
  }
};
</script>

<style></style>
